import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

export class CustomSnackBarConfig {
  /**
   * @description
   * Message to provide context to the list
   */
  message?: string;

  /**
  * @description
  * Items that will be displayed in the list
  */
  list?: string[];
}

@Component({
  selector: 'app-snackbar-list',
  templateUrl: './snackbar-list.component.html',
  styleUrls: ['./snackbar-list.component.scss']
})
export class SnackbarListComponent {

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: CustomSnackBarConfig) {}

}
